import * as React from 'react'
import { GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'
import Link from 'next/link'

import { getAllFilesFrontMatter } from '~/lib/mdx'
import Container from '~/components/Container'
import { PostFrontMatter } from '~/types'

const url = 'https://mary.ag/articles'
const title = 'Articles - Mary AG'
const description = ''

export const getStaticProps: GetStaticProps = async () => {
  const posts = await getFilteredSortedPosts()
  return { props: { posts } }
}

export default function Articles({ posts }) {
  return (
    <Container className="flex-col">
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          url,
          title,
          description
        }}
      />
      <div className="w-full">
        {posts.map(({ slug, title }) => (
          <div className="w-full" key={slug}>
            <Link href={`/articles/${slug}`}>
              <a className="hover:underline">{title}</a>
            </Link>
          </div>
        ))}
      </div>
    </Container>
  )
}

async function getFilteredSortedPosts() {
  const posts = await getAllFilesFrontMatter('articles')

  return posts
    .filter(
      (post: PostFrontMatter) =>
        process.env.NODE_ENV === 'development' || !!post.publishedAt
    )
    .sort(
      ({ publishedAt: firstDate }, { publishedAt: secondDate }) =>
        Number(new Date(secondDate)) - Number(new Date(firstDate))
    )
}
